import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { routes } from './sale-statistics.routes';
import { SOFTLINE_PERMISSION_ABAU_SALE_STATISTICS } from './sale-statistics.shared';

export function provideAbauSaleStatistics() {
  return [
    provideSoftAppsModule(
      {
        name: 'abau-sale-statistics',
        route: 'abau-sale-statistics/query',
        icon: 'fa-regular fa-chart-mixed-up-circle-dollar',
        title: 'Umsatzstatistik',
        permission: SOFTLINE_PERMISSION_ABAU_SALE_STATISTICS,
      },
      withSoftAppsModuleRoutes({ app: routes }),
      withSoftAppsModuleInfo({
        library: '@softapps/abau/umsatzstatistik',
        description: 'Kundenspezifische Umsatzstatistik für ABAU.',
      })
    ),
  ];
}
